import React from "react";
import { getInstituteContacts } from "../../../../APIs/GetAPIs";
import { Images } from "../../../../Assets/0a-exporter";
import UpdateContactDetails from "../../../Common/UpdateContactDetails/UpdateContactDetails";
import UpdateInstituteDetails from "../../../Common/UpdateInstituteDetails/UpdateInstituteDetails";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import "./institute-profile.style.scss";
export default function InstituteProfile() {
  const context = React.useContext(MainContext);
  const [openContactModal, setOpenContactModal] = React.useState(false);
  const [openBasicModal, setOpenBasicModal] = React.useState(false);
  const { userDetails, initialChecking } = context;
  const [loading, setLoading] = React.useState(true);
  console.log('userDetails',userDetails)
  return !userDetails ? (
    "Loading...."
  ) : (
    <div className="institute-profile-main">
      {openContactModal && userDetails && (
        <UpdateContactDetails
          closeIt={() => setOpenContactModal(false)}
          data={userDetails}
          updateIt={() => initialChecking()}
        />
      )}

      {openBasicModal && (
        <UpdateInstituteDetails
          initialChecking={initialChecking}
          closeIt={() => setOpenBasicModal(false)}
          data={userDetails}
        />
      )}
      <div className="institute-basic-info">
        <div className="ibi-header">
          <h5>Institute Details</h5>
          <button onClick={() => setOpenBasicModal(!openBasicModal)}>
            <img src={Images.penIcon} />
          </button>
        </div>
        <div className="ibi-body">
          <div className="ibib-left">
            <img src={userDetails?.institution_logo} />
            <div>
              <h5>{userDetails?.institution_name || "NA"}</h5>
              <p>ID 1235786</p>
            </div>
          </div>
          <div className="ibib-center">
            <div className="ibib-row">
              <span>
                <img src={Images.blueGroup} />
              </span>
              <div>
                <p>{userDetails.no_of_staff.replace("_", "-")} Staff</p>
              </div>
            </div>
            <div className="ibib-row">
              <span>
                <img src={Images.blueLocation} />
              </span>
              <div>
                <p>{userDetails?.institute_address}</p>
              </div>
            </div>
            <div className="ibib-row">
              <span>
                <img src={Images.webIcon} />
              </span>
              <div>
                <p>{userDetails.institution_website}</p>
              </div>
            </div>
          </div>
          <div className="ibib-right">
            <iframe
              src={
                "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08219783958221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1630004098978!5m2!1sen!2sin"
              }
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
      <div className="institute-contact-person">
        <div className="icp-header">
          <h5>Contact Person Details</h5>
          <button onClick={() => setOpenContactModal(true)}>
            <img src={Images.penIcon} />
          </button>
        </div>
        <div className="icp-body">
          <div className="icp-left">
            <div className="icpl-row">
              <p>
                Full Name <span>:</span>
              </p>
              <p>{userDetails?.institution_contact_name || "NA"}</p>
            </div>
            <div className="icpl-row">
              <p>
                Contact Number <span>:</span>
              </p>
              <p>{userDetails?.institution_primary_contact_no || "NA"}</p>
            </div>
            <div className="icpl-row">
              <p>
                Email ID <span>:</span>
              </p>
              <p>{userDetails?.institution_primary_email || "NA"}</p>
            </div>
          </div>
          <div className="icp-left">
            {/* <div className="icpl-row">
              <p>
                Full Name <span>:</span>
              </p>
              <p>{userDetails?.institution_contact_name || "NA"}</p>
            </div> */}
            <div className="icpl-row">
              <p>
                Alternate Contact Number <span>:</span>
              </p>
              <p>{userDetails?.institution_alternative_contact_no || "NA"}</p>
            </div>
            <div className="icpl-row">
              <p>
                Alternate Email ID <span>:</span>
              </p>
              <p>{userDetails?.institution_alternative_email || "NA"}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="institute-about">
        <div className="institute-about-header">
          <h5>About Institute</h5>
          <button onClick={() => setOpenBasicModal(!openBasicModal)}>
            <img src={Images.penIcon} />
          </button>
        </div>
        <div className="institute-about-body">
          <p>{userDetails?.about_institution}</p>
        </div>
      </div>
    </div>
  );
}
